export function JamaicaFlag({ className = "h-4 w-6" }) {
  return (
    <svg viewBox="0 0 60 40" className={className} role="img" aria-label="Flag of Jamaica">
      <rect width="60" height="40" fill="#FED100" />
      <polygon points="0,0 30,20 0,40" fill="#009B3A" />
      <polygon points="60,0 30,20 60,40" fill="#009B3A" />
      <polygon points="0,0 60,0 30,20" fill="#000000" />
      <polygon points="0,40 60,40 30,20" fill="#000000" />
    </svg>
  );
}

export function BahamasFlag({ className = "h-4 w-6" }) {
  return (
    <svg viewBox="0 0 60 40" className={className} role="img" aria-label="Flag of The Bahamas">
      <rect width="60" height="40" fill="#00A9CE" />
      <rect y="13.33" width="60" height="13.34" fill="#FFC72C" />
      <polygon points="0,0 0,40 24,20" fill="#000000" />
    </svg>
  );
}
